import { DODA_SITE_URL } from '@doda/common/src/constants/urls';

/**
 * 生成したクエリなどを元に遷移先URLを生成
 * @param searchConditionQuery
 * @returns 遷移先URL
 */
export const createUrl = (searchConditionQuery: string[]) => {
  const url = DODA_SITE_URL.careerRecommendJobList.concat(
    '?',
    searchConditionQuery.join('&')
  );

  return url;
};
